// extracted by mini-css-extract-plugin
module.exports = {"CustomOverlay":"CustomWithSpinner_CustomOverlay__1LaAO","SpinnerContainer":"CustomWithSpinner_SpinnerContainer__2Xhgm"};